/**
 * Get color based on percentage value
 * @param {number} percentage - The percentage value (0-100)
 * @returns {string} - The hex color code
 */
export const getColorFromPercentage = (percentage) => {
  if (percentage >= 100) {
    return '#7FBA00'; // Green
  } else if (percentage >= 95) {
    return '#8BC100'; // Light green
  } else if (percentage >= 90) {
    return '#97C800'; // Yellow-green
  } else if (percentage >= 85) {
    return '#A3CF00'; // Yellow-green
  } else if (percentage >= 80) {
    return '#C4D600'; // Yellow
  } else if (percentage >= 75) {
    return '#E5DD00'; // Yellow
  } else if (percentage >= 65) {
    return '#FFE400'; // Yellow
  } else if (percentage >= 50) {
    return '#FFCF00'; // Orange-yellow
  } else if (percentage >= 35) {
    return '#FFB900'; // Orange
  } else if (percentage >= 20) {
    return '#FFA400'; // Orange
  } else if (percentage >= 5) {
    return '#FF8F00'; // Dark orange
  } else {
    return '#FF6B00'; // Red-orange
  }
};

